import React, {Component} from "react";
import {Dropdown} from "primereact/dropdown";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import RemotingService from "../../services/remoting-service/RemotingService";
import StringUtil from "../../utils/StringUtil";
import PatientUtil from "../../utils/PatientUtil";
import EnumGender from "../../enums/EnumGender";
import DateUtil from "../../utils/DateUtil";
import PhoneNumberUtil from "../../utils/PhoneNumberUtil";
import {FormField} from "../../components/form";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import {DateInput, SelectInput} from "../../components";
import {Button} from "react-bootstrap";
import {Message} from "primereact/message";
import confirmDialog from "../../components/dialog/ConfirmDialog";

export default class MergePatientsModal extends Component {

    constructor(props) {
        super(props);
        props.patients.forEach(patient => {
            patient.mrnText = StringUtil.mrn(patient.mrn);

            const insurance = patient.insurance;
            if (insurance) {
                patient.insurance.insuranceText = this.formatInsuranceText(insurance);
            }
            patient.fullname = PatientUtil.getPatientsName(patient);
        });
        this.state = {
            patientsForMrn: [],
            nationalities: [],
            mobilePhones: [],
            eids: [],
            emails: [],
            addresses: [],
            insurances: []
        };
    }

    componentDidMount() {
        const patientsForMrn = this.props.patients.filter(p => p.mrn);
        const nationalities = this.props.patients.filter(p => p.nationality).map(p => p.nationality);
        const mobilePhones = this.props.patients.filter(p => p.mobilePhone).map(p => p.mobilePhone);
        const eids = this.props.patients.filter(p => p.eid).map(p => p.eid);
        const emails = this.props.patients.filter(p => p.email).map(p => p.email);
        const addresses = this.props.patients.filter(p => p.address).map(p => p.address);
        const insurances = this.props.patients.filter(p => p.insurance).map(p => p.insurance);

        this.setState({patientsForMrn, nationalities, mobilePhones, eids, emails, addresses, insurances});
    }

    formatInsuranceText(insurance) {
        if (!insurance) return "";
        return insurance.tpa?.name + " / " + insurance.company?.name + " / "
            + (insurance.network ? insurance.network?.name : " ") + " (" + insurance.memberId + ")";
    }

    confirmMerge = () => {

        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        const patientIdsToMerge = this.props.patients
            .filter(p => p.id !== this.state.selectedPatientForMrn.id)
            .map(p => p.id)
            .join(', ');

        const targetPatient = this.state.selectedPatientForMrn;

        const confirmContent = (
            <div>
                <p>Do you really want to merge the following patients? <strong>The operation is irreversible.</strong>
                </p>
                <div style={{marginTop: '15px'}}>
                    <strong>These patients will be removed:</strong> {patientIdsToMerge}
                </div>
                <div style={{marginTop: '15px'}}>
                    <strong>Merging into patient:</strong>
                    <ul style={{marginTop: '5px', paddingLeft: '20px'}}>
                        <li><strong>ID:</strong> {targetPatient.id}</li>
                        <li><strong>MRN:</strong> {StringUtil.mrn(targetPatient.mrn)}</li>
                        <li><strong>EID:</strong> {targetPatient.eid || 'N/A'}</li>
                        <li><strong>Name:</strong> {PatientUtil.getPatientsName(targetPatient)}</li>
                    </ul>
                </div>
            </div>
        );

        confirmDialog("Confirm Merge Operation", null, () => this.merge(), null, confirmContent);
    }

    merge() {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        const params = {
            patientId: this.state.selectedPatientForMrn.id,
            patientIdsToMerge: this.props.patients.filter(p => p.id !== this.state.selectedPatientForMrn.id).map(p => p.id),
            patientDetailToUpdate: {
                firstName: this.state.selectedPatientForName.firstName,
                middleName: this.state.selectedPatientForName.middleName,
                lastName: this.state.selectedPatientForName.lastName,
                birthday: this.state.birthday,
                gender: this.state.gender,
                salutation: this.state.salutation,
                nationality: this.state.nationality,
                eid: this.state.eid,
                visaStatus: this.state.visaStatus,
                mobilePhone: this.state.mobilePhone,
                email: this.state.email,
                address: this.state.address,
                insurance: this.state.insurance
            }
        };

        RemotingService.postRemoteCall('api/patient/merge', params, () => {
            this.props.close();
            this.props.onClose();
        });
    }

    handlePatientSelected(patient) {
        this.setState({
            selectedPatientForMrn: patient,
            selectedPatientForName: patient,
            selectedPatientForInsurance: patient,
            birthday: patient.birthday,
            gender: patient.gender,
            salutation: patient.salutation,
            nationality: patient.nationality,
            eid: patient.eid,
            visaStatus: patient.visaStatus,
            mobilePhone: patient.mobilePhone,
            email: patient.email,
            address: patient.address,
            insurance: patient.insurance
        })
    }

    render() {
        this.formFields = [];

        return (
            <div>
                <div className="p-grid">
                    <div className="p-col">
                        <DataTable value={this.props.patients}
                                   selectionMode="single"
                                   selection={this.state.selectedPatientForMrn}
                                   onSelectionChange={e => this.handlePatientSelected(e.value)}>
                            <Column field="id" header="Id"/>
                            <Column field="mrn.id" header="MRN" body={p => StringUtil.mrn(p.mrn)}/>
                            <Column field="eid" header="National ID"/>
                            <Column field="firstName" header="Name" body={p => PatientUtil.getPatientsName(p)}/>
                            <Column field="birthday" header="Age"
                                    body={p => p.birthday ? DateUtil.getAge(p.birthday) : '-'}/>
                            <Column field="birthday" header="Date of Birth"
                                    body={p => DateUtil.formatDateMMM(p.birthday)}/>
                            <Column field="gender" header="Gender" body={p => EnumGender[p.gender]}/>
                            <Column field="creationDate" header="Date of Registration"
                                    body={p => DateUtil.formatDateMMM(p.creationDate)}/>
                            <Column field="mobilePhone" header="Mobile Phone"
                                    body={p => PhoneNumberUtil.formatInternational(p.mobilePhone)}/>
                            <Column field="email" header="Email"/>
                        </DataTable>
                    </div>
                </div>

                <div className="p-grid">
                    <div className="p-col-6">
                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">MRN Number</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.selectedPatientForMrn?.mrn}>
                                    <Dropdown className="w-100"
                                              dataKey="id" optionLabel="mrnText"
                                              options={this.state.patientsForMrn}
                                              itemTemplate={p => StringUtil.mrn(p.mrn)}
                                              valueTemplate={p => StringUtil.mrn(p?.mrn)}
                                              value={this.state.selectedPatientForMrn}
                                              onChange={e => this.handlePatientSelected(e.value)}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Full Name</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.selectedPatientForName}>
                                    <Dropdown className="w-100"
                                              dataKey="id" optionLabel="fullname"
                                              options={this.props.patients}
                                              itemTemplate={p => PatientUtil.getPatientsName(p)}
                                              valueTemplate={p => PatientUtil.getPatientsName(p)}
                                              value={this.state.selectedPatientForName}
                                              onChange={e => this.setState({selectedPatientForName: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Date of Birth</div>
                            </div>
                            <div className="p-col-8">
                                <DateInput value={this.state.birthday}
                                           disableFuture="true"
                                           className="w-100"
                                           onChange={date => this.setState({birthday: date})}/>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Gender</div>
                            </div>
                            <div className="p-col-8">
                                <SelectInput value={this.state.gender}
                                             options={EnumGender.toArray()}
                                             displayProperty="name" valueProperty="key" searchEnabled={false}
                                             onChange={(val) => this.setState({gender: val})
                                             }
                                />
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Nationality</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.nationality}
                                           disabled={this.state.nationalities.length === 0}>
                                    <Dropdown className="w-100"
                                              dataKey="id"
                                              options={this.state.nationalities}
                                              optionLabel="name"
                                              value={this.state.nationality}
                                              onChange={e => this.setState({nationality: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">National ID</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.eid}
                                           disabled={this.state.eids.length === 0}>
                                    <Dropdown className="w-100"
                                              options={this.state.eids}
                                              value={this.state.eid}
                                              onChange={e => this.setState({eid: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Visa Status</div>
                            </div>
                            <div className="p-col-8">
                                <SelectInput value={this.state.visaStatus} searchEnabled={false}
                                             options={[
                                                 {label: 'Citizen', value: 'CITIZEN'},
                                                 {label: 'Resident', value: 'RESIDENT'},
                                                 {label: 'Visiting', value: 'VISITING'}
                                             ]}
                                             displayProperty="label" valueProperty="value"
                                             onChange={e => this.setState({visaStatus: e})}/>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Phone</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.mobilePhone}>
                                    <Dropdown className="w-100"
                                              options={this.state.mobilePhones}
                                              value={this.state.mobilePhone}
                                              onChange={e => this.setState({mobilePhone: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Email</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.email}
                                           disabled={this.state.emails.length === 0}>
                                    <Dropdown className="w-100"
                                              options={this.state.emails}
                                              value={this.state.email}
                                              onChange={e => this.setState({email: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Address</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           required validateOn={this.state.address}
                                           disabled={this.state.addresses.length === 0}>
                                    <Dropdown className="w-100"
                                              style={{whiteSpace: "pre-wrap"}}
                                              options={this.state.addresses}
                                              value={this.state.address}
                                              itemTemplate={address => <span
                                                  style={{whiteSpace: "pre-wrap"}}>{address}</span>}
                                              onChange={e => this.setState({address: e.value})}/>
                                </FormField>
                            </div>
                        </div>

                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-text-bold">Insurance</div>
                            </div>
                            <div className="p-col-8">
                                <FormField ref={formField => this.formFields.push(formField)}
                                           disabled={this.state.insurances.length === 0}>
                                    <Dropdown className="w-100"
                                              style={{whiteSpace: "pre-wrap"}}
                                              dataKey="id" optionLabel="insuranceText"
                                              options={this.state.insurances}
                                              value={this.state.insurance}
                                              itemTemplate={i => this.formatInsuranceText(i)}
                                              valueTemplate={i => this.formatInsuranceText(i)}
                                              onChange={e => this.setState({insurance: e.value})}/>
                                </FormField>
                            </div>
                        </div>
                    </div>
                    <div className="p-col-6">
                        <Message severity="warn" text={
                            <div><p>Please select the patient to merge into from the above table. This patient will be
                                preserved and others will be removed.</p>
                                <p>You can select specific attributes on the left hand side from each patient as the
                                    final value</p>
                                <p>Also following data will be merged into the selected patient:</p>
                                <ul className="p-text-bold">
                                    <li>Appointments</li>
                                    <li>Visits</li>
                                    <li>Bills & Invoices</li>
                                    <li>Insurance Records</li>
                                    <li>Prescriptions</li>
                                    <li>Credits</li>
                                    <li>Sponsorships</li>
                                    <li>Restrictions</li>
                                    <li>Reports</li>
                                </ul>
                            </div>
                        }/>
                    </div>
                </div>
                <div className="p-dialog-footer">
                    <Button variant="success" onClick={() => this.confirmMerge()}>Merge</Button>
                </div>
            </div>
        );
    }
}